
import store from './store/store.js'; // Path to your Vuex store
import {AuthError} from './custom-errors.js';

// const URL = [location.protocol, '//', location.host, location.pathname, 'api'].join('');

// const URL = `${window.location.origin}/eqtl/api`;
const URL = store.state.apiURL


import { encodeQueryString, validateRequiredFields, authFetch } from './util.js';

export default {

    plot_data(dataset_id = '', gene_id = '', molecular_trait_id= '', variant = '', callback = () => {
    }) {
        fetch(`${URL}/plot_data${encodeQueryString({dataset_id, gene_id, molecular_trait_id, variant})}`).then((response) => {
            return response.json();
        }).then((json) => {
            callback(json);
        }).catch(function (err) {
            console.log('Fetch problem: ' + err.message);
        });
    },

    page(offset = 0, limit = 50, callback = () => {
    }) {
        fetch(`${URL}/page${encodeQueryString({offset, limit})}`).then((response) => {
            return response.json();
        }).then((json) => {
            callback(json);
        }).catch(function (err) {
            console.log('Fetch problem: ' + err.message);
        });
    },

    subset(q = "", field = "", callback = () => {
    }) {
        fetch(`${URL}/subset${encodeQueryString({q, field})}`).then((response) => {
            return response.json();
        }).then((json) => {
            callback(json);
        }).catch(function (err) {
            console.log('Fetch problem: ' + err.message);
        });
    },

    search(q = "", callback = () => {
    }) {
        fetch(`${URL}/search${encodeQueryString({q})}`).then((response) => {
            return response.json();
        }).then((json) => {
            callback(json);
        }).catch(function (err) {
            console.log('Fetch problem: ' + err.message);
        });
    },

     comment() {
        const commentDetails = store.state.commentDetails;
        if (!validateRequiredFields(commentDetails)) {
            const errorDetails = {
                message: 'Validation failed: Required fields are missing.',
                type: 'danger'
            };
            return Promise.reject(errorDetails); 
        }
    
        return authFetch(`${store.state.apiURL}/comment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(commentDetails)
        })
        .then(response => {
            console.log("response", response);
            if (response.status === 401) {
                throw new AuthError('Unauthorized', response);
            }
            return response.json();
        })
        .then(data => {
            return data;  
        })
        .catch(err => {
            if (error instanceof AuthError) {
                // Re-throw as AuthError to ensure type is preserved
                return Promise.reject(new AuthError(error.message, error.response));
            }
            return Promise.reject({ message: err.message, type: 'danger' });

        });
    },
    
    getComment(credibleSet, molecularTraitId) {
        const params = {
            credible_set: credibleSet,
            molecular_trait_id: molecularTraitId,
        };
        const queryString = encodeQueryString(params);
        const url = `${store.state.apiURL}/comment${queryString}`;
    
        return authFetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            console.log("response", response);
            if (response.status === 401) {
                throw new AuthError('Unauthorized', response);
            }
            return response.json();
        })
        .then(data => {
            if (data.message === "No comment available") {
                store.dispatch('updateResponseMessage', {message: 'No comment available', type: 'info'});
                store.dispatch('clearCommentDetails');
                return null;
            }
            return data;
        })
        .catch(error => {
            if (error instanceof AuthError) {
                // Re-throw as AuthError to ensure type is preserved
                return Promise.reject(new AuthError(error.message, error.response));
            }
            return Promise.reject({ message: err.message, type: 'danger' });
        });
    },
    getAllComments() {
        const url = `${store.state.apiURL}/all-comments`;
        return authFetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 401) {
                throw new AuthError('Unauthorized', response);
            }
            return response.json();
        })
        .catch(error => {
            if (error instanceof AuthError) {
                // Re-throw as AuthError to ensure type is preserved
                return Promise.reject(new AuthError(error.message, error.response));
            }
            console.log('Fetch problem: ' + error.message);
        });
    }
    
    
    
};
